import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import AddProductToWishlist from '@client/react/components/AddProductToWishlist'

let wishlistRoot = null
let wishlistContainer = null

const cleanupWishlistModal = () => {
  if (wishlistRoot) {
    wishlistRoot.unmount()
    wishlistRoot = null
  }
  if (wishlistContainer && wishlistContainer.parentNode) {
    wishlistContainer.parentNode.removeChild(wishlistContainer)
    wishlistContainer = null
  }
}

export const showWishlistModal = (productId, productName, imageUrl) => {
  if (!window.reduxStore) {
    console.error('Redux store not available')
    return
  }

  cleanupWishlistModal()

  wishlistContainer = document.createElement('div')
  wishlistContainer.id = 'tweakwise-wishlist-modal'
  document.body.appendChild(wishlistContainer)

  wishlistRoot = createRoot(wishlistContainer)

  const WishlistWrapper = () => {
    const [show, setShow] = React.useState(true)

    const handleClose = () => {
      setShow(false)
      setTimeout(cleanupWishlistModal, 100)
    }

    return (
      <Provider store={window.reduxStore}>
        <AddProductToWishlist
          product={{ id: parseInt(productId), name: productName, image: imageUrl }}
          show={show}
          onClose={handleClose}
        />
      </Provider>
    )
  }

  wishlistRoot.render(<WishlistWrapper />)
}

if (typeof document !== 'undefined') {
  document.addEventListener('turbolinks:before-render', cleanupWishlistModal)
  document.addEventListener('turbolinks:before-cache', cleanupWishlistModal)
  document.addEventListener('turbolinks:visit', cleanupWishlistModal)
  
  window.addEventListener('beforeunload', cleanupWishlistModal)
}
